<script>
import AppSelector from '../pages/AppSelector.vue'

import Home from '../pages/Home.vue'
import Login from '../components/layout/Login.vue'
import Admin from '../components/layout/Admin.vue'
import Initial from '../components/layout/Initial.vue'
	
import Box from '../pages/box/Box'
import EditBox from '../pages/box/EditBox'

import Lock from '../pages/lock/Lock'
import EditLock from '../pages/lock/EditLock'
	
import User from '../pages/user/User'
import EditUser from '../pages/user/EditUser'
import Permit from '../pages/user/Permit'
	
import Profile from '../pages/profile/Profile'
	
import Partner from '../pages/partner/Partner'
import EditPartner from '../pages/partner/EditPartner'
	
import Position from '../pages/position/Position'
	
import Location from '../pages/location/Location'
	
import Task from '../pages/task/Task'
import EditTask from '../pages/task/EditTask'
	
import EditIsolation from '../pages/isolation/EditIsolation'
	
import Unit from '../pages/units/Unit'
import EditUnit from '../pages/units/EditUnit'
	
import Notification from '../pages/notification/Notification'
	
import Workflow from '../pages/workflow/Workflow'
import EditWorkflow from '../pages/workflow/EditWorkflow'
	
import IsolationLog from '../pages/logs/IsolationLog'
import LockLog from '../pages/logs/LockLog'
import PositionLog from '../pages/logs/PositionLog'
import LogDetail from '../pages/logs/LogDetail'

import Draft from '../pages/drafts/Draft'

import Workplace from '../pages/workplaces/Workplace'

import Workjob from '../pages/workjobs/Workjob'

import TemporaryReconnect from '../pages/temporary_reconnects/TemporaryReconnect'
	
import DocsForUsers from '../components/DocsForUsers'
import DocsForPrint from '../components/DocsForPrint'
import UnderConstruction from '../components/UnderConstruction'

import CraneIndex from '../pages/cranes/Index'
import CraneLog from '../pages/logs/CraneLog'
import DailyTasks from '../pages/daily_tasks/DailyTasks.vue'
import SubComponentContainer from '../components/SubComponentContainer.vue'

import SystemMessages from '../pages/system_messages/SystemMessages.vue'

const routes = [  	
	{ 
		path: '/',
		component: Initial,
		name: 'Initial',
		meta: { layout: Initial, authOnly: true, available_modes: [1]}
	},
	{
		path: '/login',
		component: Login,
		name:'Login',
		meta: { layout: Login, guestOnly: true , available_modes: [1]}
	},
	{ 
		path: '/under-construction',
		component: UnderConstruction,
		name: 'UnderConstruction',
		meta: { layout: Admin, authOnly: true, available_modes: [1]}
	},
	{ 
		path: '/app-selector',
		component: AppSelector,
		name: 'AppSelector',
		meta: { layout: Admin, authOnly: true , available_modes: [1,2,3,4]}
	},
	{ 
		path: '/dashboard',
		component: Home,
		name: 'Dashboard',
		visibleInMenu: true,
		icon: 'fab fa-delicious',
		title: 'Összesítőpult',
		meta: { layout: Admin, authOnly: true , available_modes: [1]}
	},
	{
		path: '/tasks',
		component: Task,
		visibleInMenu: true,
		icon: 'fa fa-ticket',
		title: 'Munkafolyamatok',
		meta: { layout: Admin, authOnly: true , roles: [1,2,3,4,5,7,8], available_modes: [1]}
	},
	{
		path: '/tasks/:id/edit',
		component: EditTask,
		meta: { layout: Admin, authOnly: true , available_modes: [1]}
	},
	{ 
		path: '/temporary-reconnects',
		component: TemporaryReconnect,
		visibleInMenu: true,
		icon:'fa fa-plug', 
		title: 'Ideiglenes fesz. alá helyezések',
		name: 'TemporaryReconnect',
		meta: { layout: Admin, authOnly: true , roles:[1,2,3,4,5,7], available_modes: [1]}
	},
	{ 
		path: '/drafts',
		component: Draft,
		name: 'Draft',
		visibleInMenu: true,
		icon:'fa fa-compass-drafting',
		title: 'Vázlatok', 
		meta: { layout: Admin, authOnly: true , roles:[5,6,7,8], available_modes: [1]}
	},	 
	{
		path: '/workflows',
		component: Workflow,
		visibleInMenu: true,
		icon:'fa fa-project-diagram', 
		title: 'Utasítások',
		meta: { layout: Admin, authOnly: true , roles:[1,2,3,4,5,7], available_modes: [1]}
	},
	{
		path: '/workflows/:id/edit',
		component: EditWorkflow,
		meta: { layout: Admin, authOnly: true , available_modes: [1]}
	},
	{
		path: '/logs',
		component: SubComponentContainer,
		visibleInMenu: true,
		icon:'fa fa-book-open', 
		title: 'Naplók',
		children:[
			{
				path: 'isolations',
				component: IsolationLog,
				visibleInMenu: true,
				icon: 'fa fa-bolt',
				title: 'Feszültségmentesítés',
				meta: { layout: Admin, authOnly: true , roles:[1,2,3,4,5,7,8,9], available_modes: [1]}
			},
			{
				path: 'locks',
				component: LockLog,
				visibleInMenu: true,
				icon: 'fa fa-lock',
				title: 'Lakatok',
				meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5,7,8,9], available_modes: [1]}
			},
			{
				path: 'positions',
				component: PositionLog,
				visibleInMenu: true,
				icon:'fa fa-charging-station', 
				title: 'Berendezések', 
				meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5,7,8,9], available_modes: [1]}
			},
			{
				path: 'cranes',
				component: CraneLog,
				visibleInMenu: true,
				icon:'fa fa-arrow-down-up-across-line', 
				title: 'Emelőgépek ',
				meta: { layout: Admin, authOnly: true , roles:[1,2,3,4,5,7,8,9], available_modes: [1]}
			},
			{
				path: ':id/details',
				component: LogDetail,
				visibleInMenu: false,
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
		],
		meta: { layout: Admin, authOnly: true,  roles:[1,2,3,4,5,7,8,9], available_modes: [1]}
	},
	{
		path: '/base-data',
		component: SubComponentContainer,
		visibleInMenu: true,
		icon:'fa fa-boxes', 
		title: 'Törzsadatok',
		meta: { layout: Admin, authOnly: true,  roles:[1,2,3,4,5,7,8,9], available_modes: [1]},
		children:[
			{
				path: 'locations',
				component: Location,
				visibleInMenu: true,
				icon: 'fas fa-hard-hat',
				title: 'Munkaterület',
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'units',
				component: Unit,
				visibleInMenu: true, 
				icon:'fas fa-vector-square', 
				title: 'Egységek',
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'units/:id/edit',
				component: EditUnit,
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'positions',
				component: Position,
				visibleInMenu: true,
				icon:'fa fa-bolt', 
				title: 'Hajtások',
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'locks',
				component: Lock,
				visibleInMenu: true,
				icon: 'fa fa-lock', 
				title: 'Lakatok',
				meta: { layout:Admin, authOnly: true, roles:[1,2,3,5,7], available_modes: [1]}
			},
			{
				path: 'locks/:id/edit',
				component: EditLock,
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'boxes',
				component: Box,
				visibleInMenu: true,
				icon: 'fa fa-user-lock', 
				title: 'Szekrények',
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'boxes/:id/edit',
				component: EditBox,
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'users',
				component: User,
				visibleInMenu: true,
				icon: 'fa fa-users', 
				title: 'Felhasználók',
				meta: { layout: Admin, authOnly: true, roles:[1,2,3,5,7], available_modes: [1]}
			},
			{
				path: 'users/permits',
				component: Permit,
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'users/:id/edit',
				component: EditUser,
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'partners',
				component: Partner,
				visibleInMenu: true,
				icon:'fa fa-users', 
				title: 'Partnerek',
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'partners/:id/edit',
				component: EditPartner,
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
			{
				path: 'workplaces',
				component: Workplace,
				visibleInMenu: true,
				icon:'fa fa-person-digging', 
				title: 'Munkahelyek',
				meta: { layout: Admin, authOnly: true , roles:[1,2,3,5,7], available_modes: [1]}
			},
			{
				path: 'workjobs',
				component: Workjob,
				visibleInMenu: true,
				icon:'fa fa-helmet-safety', 
				title: 'Munkakörök',
				meta: { layout: Admin, authOnly: true , roles:[1,2,3,5,7], available_modes: [1]}
			},	
			{
				path: 'cranes',
				component: CraneIndex,
				visibleInMenu: true, 
				icon:'fa fa-arrow-down-up-across-line', 
				title: 'Emelőgépek',
				meta: { layout: Admin, authOnly: true , roles:[1,2,3,5,7], available_modes: [1]}
			},			
		],
		
	},
	{ 
		path: '/daily-tasks',
		component: DailyTasks,
		name: 'DailyTasks',
		visibleInMenu: true,
		icon: 'fa fa-list-check',
		title: 'Feladatok',
		meta: { layout: Admin, authOnly: true, available_modes: [2] }
	},
	{
		path: '/settings',
		component: SubComponentContainer,
		visibleInMenu: true,
		icon:'fa fa-cog', 
		title: 'Beállítások',
		children:[
			{
				path: 'profile',
				component: Profile,
				name: "Profile",
				visibleInMenu: true,
				icon: 'fa fa-user',
				title: 'Személyes',
				meta: { layout: Admin, authOnly: true , available_modes: [1]}
			},
		],
		meta: { layout: Admin, authOnly: true,  roles:[1,2,3,4,5,6,7,8,9], available_modes: [1]}
	},
	{
		path: '/docs-for-print',
		component: DocsForPrint,
		visibleInMenu: true,
		icon: 'fa fa-print',
		title: 'Vállalkozói engedélyek nyomtatásra',
		meta: { layout: Admin, authOnly: true , available_modes: [1]}
	},
	{
		path: '/docs-for-users',
		component: DocsForUsers,
		visibleInMenu: true,
		icon: 'fa fa-print',
		title: 'Letölthető fájlok',
		meta: { layout: Admin, authOnly: true , available_modes: [1]}
	},
	{
		path: '/isolations/:id/edit',
		component: EditIsolation,
		meta: { layout: Admin, authOnly: true , available_modes: [1]}
	},
	
	{
		path: '/notifications',
		component: Notification,
		meta: { layout: Admin, authOnly: true , available_modes: [1]}
	},
	{ 
		path: '/system-messages',
		component: SystemMessages,
		name: 'SystemMessages',
		visibleInMenu: true,
		icon: 'fa fa-list-check',
		title: 'Rendszerüzenetek',
		meta: { layout: Admin, authOnly: true, roles: [1], available_modes: [4] }
	},
]

export default routes;
</script>
